//============================================================================
//============================== Permissions =================================
//============================================================================
export const ROLE_LIST_SK = 'role-list';
export const ROLE_CREATE_SK = 'role-create';
export const ROLE_EDIT_SK = 'role-edit';
export const ROLE_DELETE_SK = 'role-delete';
export const ROLE_VIEW_SK = 'role-view';

export const PERMISSION_LIST_SK = 'permission-list';
export const PERMISSION_CREATE_SK = 'permission-create';
export const PERMISSION_EDIT_SK = 'permission-edit';
export const PERMISSION_DELETE_SK = 'permission-delete';

export const USER_LIST_SK = 'user-list';
export const USER_CREATE_SK = 'user-create';
export const USER_EDIT_SK = 'user-edit';
export const USER_DELETE_SK = 'user-delete';

export const WAREHOUSE_LIST_SK = 'warehouse-list';
export const WAREHOUSE_CREATE_SK = 'warehouse-create';
export const WAREHOUSE_EDIT_SK = 'warehouse-edit';
export const WAREHOUSE_DELETE_SK = 'warehouse-delete';

export const SUPPLIER_LIST_SK = 'supplier-list';
export const SUPPLIER_CREATE_SK = 'supplier-create';
export const SUPPLIER_EDIT_SK = 'supplier-edit';
export const SUPPLIER_DELETE_SK = 'supplier-delete';

export const SHOP_LIST_SK = 'shop-list';
export const SHOP_CREATE_SK = 'shop-create';
export const SHOP_EDIT_SK = 'shop-edit';
export const SHOP_DELETE_SK = 'shop-delete';

export const UOM_LIST_SK = 'uom-list';
export const UOM_CREATE_SK = 'uom-create';
export const UOM_EDIT_SK = 'uom-edit';
export const UOM_DELETE_SK = 'uom-delete';

export const UOM_CONVERSION_LIST_SK = 'uom-conversion-list';
export const UOM_CONVERSION_CREATE_SK = 'uom-conversion-create';
export const UOM_CONVERSION_EDIT_SK = 'uom-conversion-edit';
export const UOM_CONVERSION_DELETE_SK = 'uom-conversion-delete';

export const BANK_LIST_SK = 'bank-list';
export const BANK_CREATE_SK = 'bank-create';
export const BANK_EDIT_SK = 'bank-edit';
export const BANK_DELETE_SK = 'bank-delete';
export const BANK_VIEW_SK = 'bank-view';

export const CATEGORY_LIST_SK = 'category-list';
export const CATEGORY_CREATE_SK = 'category-create';
export const CATEGORY_EDIT_SK = 'category-edit';
export const CATEGORY_DELETE_SK = 'category-delete';
export const CATEGORY_VIEW_SK = 'category-view';

// Consumption Type
export const CONSUMPTION_TYPE_LIST_SK = 'consumption-type-list';
export const CONSUMPTION_TYPE_CREATE_SK = 'consumption-type-create';
export const CONSUMPTION_TYPE_EDIT_SK = 'consumption-type-edit';
export const CONSUMPTION_TYPE_DELETE_SK = 'consumption-type-delete';
export const CONSUMPTION_TYPE_VIEW_SK = 'consumption-type-view';

// Raw Material
export const RAW_MATERIAL_LIST_SK = 'raw-material-list';
export const RAW_MATERIAL_CREATE_SK = 'raw-material-create';
export const RAW_MATERIAL_EDIT_SK = 'raw-material-edit';
export const RAW_MATERIAL_DELETE_SK = 'raw-material-delete';
export const RAW_MATERIAL_VIEW_SK = 'raw-material-view';
export const RAW_MATERIAL_ACTIVATE_SK = 'raw-material-activate';
// Legacy FE-only (backend case commented out) — do not use for new guards.
export const RAW_MATERIAL_ORDER_AVAILABLE_SK = 'raw-material-order-available';

// Purchase
export const PURCHASE_LIST_SK = 'purchase-list';
export const PURCHASE_CREATE_SK = 'purchase-create';
export const PURCHASE_EDIT_SK = 'purchase-edit';
export const PURCHASE_DELETE_SK = 'purchase-delete';
export const PURCHASE_VIEW_SK = 'purchase-view';
export const PURCHASE_STATUS_EDIT_SK = 'purchase-status-edit';
export const PURCHASE_REVERSE_RECEIPT_SK = 'purchase-reverse-receipt';

// Bill
export const BILL_LIST_SK = 'bill-list';
export const BILL_CREATE_SK = 'bill-create';
export const BILL_EDIT_SK = 'bill-edit';
export const BILL_DELETE_SK = 'bill-delete';
export const BILL_VIEW_SK = 'bill-view';

// Payment Made
export const PAYMENT_LIST_SK = 'payment-list';
export const PAYMENT_CREATE_SK = 'payment-create';
export const PAYMENT_VIEW_SK = 'payment-view';
export const PAYMENT_EDIT_SK = 'payment-edit';

// Legacy FE-only (backend PermissionNames cases are commented out) — do not use for new guards.
export const CREDIT_PURCHASE_LIST_SK = 'credit-purchase-list';
export const CREDIT_PURCHASE_PAYMENT_SK = 'credit-purchase-payment';
export const CREDIT_PAYMENT_LIST_SK = 'credit-payment-list';
export const CREDIT_PAYMENT_VIEW_SK = 'credit-payment-view';
export const CREDIT_PAYMENT_MAKE_SK = 'credit-payment-make';

// Finished Good
export const FINISHED_GOOD_LIST_SK = 'finished-good-list';
export const FINISHED_GOOD_CREATE_SK = 'finished-good-create';
export const FINISHED_GOOD_EDIT_SK = 'finished-good-edit';
export const FINISHED_GOOD_DELETE_SK = 'finished-good-delete';
export const FINISHED_GOOD_VIEW_SK = 'finished-good-view';
export const FINISHED_GOOD_ACTIVATE_SK = 'finished-good-activate';

// Production
export const PRODUCTION_LIST_SK = 'production-list';
export const PRODUCTION_CREATE_SK = 'production-create';
export const PRODUCTION_EDIT_SK = 'production-edit';
export const PRODUCTION_DELETE_SK = 'production-delete';
export const PRODUCTION_VIEW_SK = 'production-view';

// Production Order
export const PRODUCTION_ORDER_LIST_SK = 'production-order-list';
export const PRODUCTION_ORDER_CREATE_SK = 'production-order-create';
export const PRODUCTION_ORDER_EDIT_SK = 'production-order-edit';
export const PRODUCTION_ORDER_DELETE_SK = 'production-order-delete';
export const PRODUCTION_ORDER_VIEW_SK = 'production-order-view';

// Inventory
export const INVENTORY_LIST_SK = 'inventory-list';
export const INVENTORY_VIEW_SK = 'inventory-view';
export const INVENTORY_IMPORT_OPENING_STOCK_SK = 'inventory-import-opening-stock';

// Stock Movement
export const STOCK_MOVEMENT_LIST_SK = 'stock-movement-list';
export const STOCK_MOVEMENT_CREATE_SK = 'stock-movement-create';

// Stock Adjustment
export const STOCK_ADJUSTMENT_LIST_SK = 'stock-adjustment-list';
export const STOCK_ADJUSTMENT_CREATE_SK = 'stock-adjustment-create';
export const STOCK_ADJUSTMENT_EDIT_SK = 'stock-adjustment-edit';
export const STOCK_ADJUSTMENT_DELETE_SK = 'stock-adjustment-delete';

// Internal Transfer
export const INTERNAL_TRANSFER_LIST_SK = 'internal-transfer-list';
export const INTERNAL_TRANSFER_CREATE_SK = 'internal-transfer-create';
export const INTERNAL_TRANSFER_EDIT_SK = 'internal-transfer-edit';
export const INTERNAL_TRANSFER_DELETE_SK = 'internal-transfer-delete';
export const INTERNAL_TRANSFER_VIEW_SK = 'internal-transfer-view';

// Stock Request
export const STOCK_REQUEST_LIST_SK = 'stock-request-list';
export const STOCK_REQUEST_CREATE_SK = 'stock-request-create';
export const STOCK_REQUEST_EDIT_SK = 'stock-request-edit';
export const STOCK_REQUEST_DELETE_SK = 'stock-request-delete';
export const STOCK_REQUEST_VIEW_SK = 'stock-request-view';

export const WAREHOUSE_ORDER_LIST_SK = 'warehouse-order-list';
export const WAREHOUSE_ORDER_CREATE_SK = 'warehouse-order-create';
export const WAREHOUSE_ORDER_UPDATE_SK = 'warehouse-order-update';
export const WAREHOUSE_ORDER_CONFIRM_SK = 'warehouse-order-confirm';
export const WAREHOUSE_ORDER_CANCEL_SK = 'warehouse-order-cancel';
export const WAREHOUSE_ORDER_VIEW_SK = 'warehouse-order-view';

export const WAREHOUSE_TRANSFER_LIST_SK = 'warehouse-transfer-list';
export const WAREHOUSE_TRANSFER_CREATE_SK = 'warehouse-transfer-create';
export const WAREHOUSE_TRANSFER_UPDATE_SK = 'warehouse-transfer-update';
export const WAREHOUSE_TRANSFER_CONFIRM_SK = 'warehouse-transfer-confirm';
export const WAREHOUSE_TRANSFER_TRANSFER_SK = 'warehouse-transfer-transfer';
export const WAREHOUSE_TRANSFER_CANCEL_SK = 'warehouse-transfer-cancel';
export const WAREHOUSE_TRANSFER_VIEW_SK = 'warehouse-transfer-view';

export const WAREHOUSE_RECEIPT_LIST_SK = 'warehouse-receipt-list';
export const WAREHOUSE_RECEIPT_CREATE_SK = 'warehouse-receipt-create';
export const WAREHOUSE_RECEIPT_UPDATE_SK = 'warehouse-receipt-update';
export const WAREHOUSE_RECEIPT_RECEIVE_SK = 'warehouse-receipt-receive';
export const WAREHOUSE_RECEIPT_CANCEL_SK = 'warehouse-receipt-cancel';
export const WAREHOUSE_RECEIPT_VIEW_SK = 'warehouse-receipt-view';

// Order
export const ORDER_LIST_SK = 'order-list';
export const ORDER_VIEW_SK = 'order-view';
export const ORDER_CREATE_SK = 'order-create';
export const ORDER_STATUS_EDIT_SK = 'order-status-edit';
export const ORDER_ITEM_EDIT_SK = 'order-item-edit';
export const ORDER_DELETE_SK = 'order-delete';

export const SHOP_CATEGORY_LIST_SK = 'shop-category-list';
export const SHOP_ITEM_LIST_SK = 'shop-item-list';

export const STOCK_RETURN_LIST_SK = 'stock-return-list';
export const STOCK_RETURN_CREATE_SK = 'stock-return-create';
export const STOCK_RETURN_VIEW_SK = 'stock-return-view';

export const SALE_LIST_SK = 'sale-list';
export const SALE_VIEW_SK = 'sale-view';

export const PRICE_CHANGE_SK = 'price-change';

// UI-only: backend has no dashboard PermissionNames; route is intentional auth-only.
export const DASHBOARD_SK = 'dashboard';

// Par Level (backend canonical)
export const PAR_LEVEL_LIST_SK = 'par-level-list';
export const PAR_LEVEL_CREATE_SK = 'par-level-create';
export const PAR_LEVEL_EDIT_SK = 'par-level-edit';
export const PAR_LEVEL_DELETE_SK = 'par-level-delete';

export const ORDER_REPORT_LIST_SK = 'order-report-list';
export const SALE_REPORT_LIST_SK = 'sale-report-list';
export const PURCHASE_REPORT_LIST_SK = 'purchase-report-list';
export const BILL_REPORT_LIST_SK = 'bill-report-list';
export const PAYMENT_REPORT_LIST_SK = 'payment-report-list';
export const STOCK_MOVEMENT_REPORT_LIST_SK = 'stock-movement-report-list';
export const STOCK_ORDER_SUMMARY_REPORT_LIST_SK = 'stock-order-summary-report-list';
export const DAILY_STOCK_SUMMARY_REPORT_LIST_SK = 'daily-stock-summary-report-list';
export const DAILY_INVENTORY_VALUATION_REPORT_LIST_SK = 'daily-inventory-valuation-report-list';
export const ESTIMATED_PRODUCTION_BALANCE_REPORT_LIST_SK = 'estimated-production-balance-report-list';
export const PURCHASE_HISTORY_LIST_SK = 'purchase-history-list';

// Brand
export const BRAND_LIST_SK = 'brand-list';
export const BRAND_CREATE_SK = 'brand-create';
export const BRAND_EDIT_SK = 'brand-edit';
export const BRAND_DELETE_SK = 'brand-delete';

// Region
export const REGION_LIST_SK = 'region-list';
export const REGION_CREATE_SK = 'region-create';
export const REGION_EDIT_SK = 'region-edit';
export const REGION_DELETE_SK = 'region-delete';

// Expense
export const EXPENSE_LIST_SK = 'expense-list';
export const EXPENSE_CREATE_SK = 'expense-create';
export const EXPENSE_EDIT_SK = 'expense-edit';
export const EXPENSE_DELETE_SK = 'expense-delete';
export const EXPENSE_VIEW_SK = 'expense-view';
export const EXPENSE_APPROVE_SK = 'expense-approve';

// Expense Header / Subheader — MAP TO backend expense-* (controllers use expense-list/create/edit/delete)
export const EXPENSE_HEADER_LIST_SK = 'expense-list';
export const EXPENSE_HEADER_CREATE_SK = 'expense-create';
export const EXPENSE_HEADER_EDIT_SK = 'expense-edit';
export const EXPENSE_HEADER_DELETE_SK = 'expense-delete';
export const EXPENSE_SUBHEADER_LIST_SK = 'expense-list';
export const EXPENSE_SUBHEADER_CREATE_SK = 'expense-create';
export const EXPENSE_SUBHEADER_EDIT_SK = 'expense-edit';
export const EXPENSE_SUBHEADER_DELETE_SK = 'expense-delete';

// Warehouse Consumption
export const WAREHOUSE_CONSUMPTION_LIST_SK = 'warehouse-consumption-list';
export const WAREHOUSE_CONSUMPTION_CREATE_SK = 'warehouse-consumption-create';
export const WAREHOUSE_CONSUMPTION_EDIT_SK = 'warehouse-consumption-edit';
export const WAREHOUSE_CONSUMPTION_DELETE_SK = 'warehouse-consumption-delete';
export const WAREHOUSE_CONSUMPTION_VIEW_SK = 'warehouse-consumption-view';
